 /*

 Copyright (C) 2017 Jayesh Salvi, Blue Math Software Inc.

 This file is part of bluemath.

 bluemath is free software: you can redistribute it and/or modify
 it under the terms of the GNU Affero General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 bluemath is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 GNU Affero General Public License for more details.

 You should have received a copy of the GNU Affero General Public License
 along with bluemath. If not, see <http://www.gnu.org/licenses/>.

*/

import {NDArray} from '@bluemath/common'
import {HalfEdge} from './halfedge'
import {IDManager} from './idman'

export type walkHandler = (he:HalfEdge, count:number) => void;

export class Vertex {

  coord? : NDArray;
  halfedge? : HalfEdge;
  id : string;

  constructor(coord?:NDArray, halfedge?:HalfEdge) {
    this.coord = coord;
    this.halfedge = halfedge;
    this.id = 'V'+IDManager.genId('V');
  }

  walk(heStart:HalfEdge, callback:walkHandler) {
    console.assert(heStart.vertex === this);
    let count = 0;
    let heCursor = heStart;
    do {
      callback(heCursor, count);
      console.assert(heCursor.mate().next);
      heCursor = heCursor.mate().next!;
      count++;
    } while(heCursor !== heStart);
  }

  degree() : number {
    let he = this.halfedge;
    console.assert(he);
    if(he!.isSolitary()) {
      return 0;
    }
    let i=0;
    do {
      i++;
      he = he!.mate().next;
    } while(he !== this.halfedge);
    return i;
  }

  unlink() {
    this.halfedge = undefined;
  }
}


// WEBPACK FOOTER //
// ./src/topo/vertex.ts